module.exports = __webpack_public_path__ + "img/组 18-2.435ba1a1.png";